export default __webpack_public_path__ + "static/media/muamalat-color.82569ebe.svg";